const formatRoutes = (routes = [], options = { breadcrumbs: true, backControl: true, layout: 'redesign' }) => routes.map((route) => {
  const meta = route.meta || {};
  const { breadcrumbs, backControl, layout } = options;
  return {
    ...route,
    meta: {
      navigation: {
        breadcrumbs,
        back: meta.navigation?.back ?? backControl,
      },
      ...meta,
      layout,
    },
    children: (route.children || []).map((child) => ({
      ...child,
      meta: {
        ...meta,
        ...child.meta,
        layout,
      },
    })),
  };
});

export default formatRoutes;
